import { useEffect, useRef } from 'react';
import { Canvas, Polyline, FabricObject, BasicTransformEvent } from 'fabric';

import { clearGuideLines, handleObjectMoving } from '../utils/snapping-helper';

export const useSnappingGuides = (
  canvas: Canvas | null,
  designWidth: number = 1,
  designHeight: number = 1
) => {
  const guidelinesRef = useRef<Polyline[]>([]);

  useEffect(() => {
    if (!canvas) return;

    const handleMoving = (e: BasicTransformEvent & { target: FabricObject }) => {
      handleObjectMoving(canvas, e.target, designWidth, designHeight);
    };

    const handleModified = () => {
      clearGuideLines(canvas);
      guidelinesRef.current = [];
    };

    canvas.on('object:moving', handleMoving);
    canvas.on('object:modified', handleModified);
    canvas.on('mouse:up', handleModified);

    return () => {
      canvas.off('object:moving', handleMoving);
      canvas.off('object:modified', handleModified);
      canvas.off('mouse:up', handleModified);
    };
  }, [canvas]);
};
